import {
  amendFoundAddressee,
  getAddressBySuggestionId,
  searchAddressesResultSet,
  resetAddressSuggestionNotAddress,
} from 'redux/modules/address-suggestion/actions';

const RESULTSET = 'RESULT_SET';

const selectSuggestedAddress =
  ({ id, type, existingValues }) =>
  async dispatch => {
    if (type && type.toUpperCase() === RESULTSET) {
      return dispatch(searchAddressesResultSet(id));
    }

    await dispatch(getAddressBySuggestionId(id));
    await dispatch(amendFoundAddressee(existingValues));
    return dispatch(resetAddressSuggestionNotAddress());
  };

export { selectSuggestedAddress };
